export const MEMBER_LOGIN_KEY_NEW_CAR_PROMOTION_ALERT = (
  'new-car-promotion-alert'
);
